import produce from 'immer'
import { actionTypes } from '../actions/cartActions'
import { StorageKeys } from '../constants/index'
import { setObjectData, getObjectData } from '../utils/localStorageHelper'
import { REFRESH_DATA } from '../actions/actionTypes'

const initialState = getObjectData(StorageKeys.cartDetails) || {
    ordering: [],
    ordered: [],
}

const CartReducer = (state = initialState, action) => {
    let newChange = false
    const newState = produce(state, draft => {
        switch (action.type) {
            case actionTypes.SUBMIT_OREDER_SUCCESS: {
                const {
                    tableOrderDataId,
                    state,
                    allow_view_order,
                } = action.payload
                if (allow_view_order) {
                    draft.ordered.push({
                        state,
                        tableOrderDataId,
                        list: draft.ordering,
                    })
                } else {
                    draft.ordered = []
                }
                draft.ordering = []
                newChange = true
                break
            }
            case actionTypes.UPDATE_FOOD_STATE: {
                const { index, state } = action.payload
                draft.ordered[index].state = state
                newChange = true
                break
            }
            case REFRESH_DATA: {
                draft.ordered = []
                draft.ordering = []
                newChange = true
                break
            }
            default:
                return state
        }
    })
    if (newChange) {
        setObjectData(StorageKeys.cartDetails, newState)
    }
    return newState
}

export default CartReducer
